import "../styles/globals.css";
import type { AppProps } from "next/app";
import { createTheme } from "../theme";
import { ThemeProvider } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import type { EmotionCache } from "@emotion/react";
import { observer } from "mobx-react-lite";
import ThemeStore from "../stores/ThemeStore";
import { CssBaseline } from "@mui/material";
import nProgress from "nprogress";
import { createEmotionCache } from "../utils/createEmotionCache";
import { Router } from "next/router";
import React from "react";
import { gtm } from "../utils/gtm";
import { captureAttribution } from "../utils/attribution";
import Head from "next/head";

// const clientSideEmotionCache = createEmotionCache();

Router.events.on("routeChangeStart", nProgress.start);
Router.events.on("routeChangeError", nProgress.done);
Router.events.on("routeChangeComplete", nProgress.done);

const App = observer(
    ({
        Component,
        // emotionCache = clientSideEmotionCache,
        pageProps,
    }: AppProps & { emotionCache: EmotionCache }) => {
        React.useEffect(() => {
            gtm.initialize({
                containerId: "GTM-KWDGXKW",
            });

            // Record acquisition attribution (first- and last-touch) at the start of each visit,
            // before intra-site navigation can overwrite document.referrer. Runs on every page load
            // so a return visit (next day/week) updates the last-touch source.
            captureAttribution();

            function resize() {
                const doc = document.documentElement;
                doc.style.setProperty(
                    "--app-height",
                    `${window.innerHeight}px`,
                );
            }

            document.addEventListener("resize", resize);

            return () => {
                document.removeEventListener("resize", resize);
            };
        }, []);

        return (
            <>
                <Head>
                    <title>AuthentiGATE Tickets</title>
                    <meta
                        name="viewport"
                        content="width=device-width, initial-scale=1"
                    />
                    {/* <meta
                        httpEquiv="Content-Security-Policy"
                        content="default-src 'self' 'unsafe-inline' blob: https://* https://tickets.authentigate.ca https://tickets-alt.authentigate.ca https://admin-api.authentigate.ca https://www.google.com https://www.gstatic.com https://js.authorize.net https://api.authorize.net https://*.ccdc02.com https://*.cardinalcommerce.com https://*.online-metrix.net https://kg668dbov0.execute-api.us-east-1.amazonaws.com https://sealserver.trustwave.com https://*.doubleclick.net https://*.quantserve.com https://*.adsrvr.org https://*.eyereturn.com https://*.quantcount.com https://*.zedo.com https://*.adnxs.com https://static.zdassets.com https://ekr.zdassets.com https://authentigate.zendesk.com wss://authentigate.zendesk.com; object-src 'self' blob:; style-src 'self' 'unsafe-inline' https://tagmanager.google.com/ https://fonts.googleapis.com/ https://*.squarecdn.com; img-src * 'self' 'unsafe-inline' data:; frame-src https://*; font-src https://*; connect-src wss://* https://*;"
                    /> */}
                    <link
                        rel="icon"
                        href="https://cdn.authentigate.ca/clients/28/ag_favicon.png"
                    />
                </Head>
                {/* <CacheProvider value={emotionCache}> */}
                <ThemeProvider
                    theme={createTheme({
                        direction: "ltr",
                        mode: ThemeStore.mode,
                        primary: ThemeStore.primaryColor,
                        text: ThemeStore.textColor,
                    })}
                >
                    <Component {...pageProps} />
                    <CssBaseline />
                </ThemeProvider>
                {/* </CacheProvider> */}
            </>
        );
    },
);

export default App;
